// Client-side Datadog logging (using direct API calls)

interface ClientErrorData {
  component?: string;
  action?: string;
  customData?: Record<string, any>;
}

// Send error via server-side API endpoint
export const logClientError = async (
  error: unknown | any,
  context: ClientErrorData,
): Promise<void> => {
  return;
  try {
    let errorObj = {
      message: "",
      stack: "",
      name: "",
    };
    if (error instanceof Error) {
      errorObj = {
        message: error.message,
        stack: error.stack || "",
        name: error.name,
      };
    } else if (typeof error === "object" && error !== null) {
      errorObj = {
        message: (error as any).message || "",
        stack: (error as any).stack || "",
        name: (error as any).name || "",
      };
    } else {
      errorObj = {
        message: String(error),
        stack: "",
        name: "",
      };
    }
    const errorData = {
      error: errorObj,
      context: {
        ...context,
        url: typeof window !== "undefined" ? window.location.href : "unknown",
        referrer: typeof window !== "undefined" ? document.referrer : "unknown",
        userAgent:
          typeof window !== "undefined" ? navigator.userAgent : "unknown",
        timestamp: new Date().toISOString(),
        environment: "client",
        errorType: "client-side",
      },
    };
    const response = await fetch("/api/log-client-error", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(errorData),
    });
    if (response.ok) {
      console.log("✅ Client error sent to Datadog via API successfully");
    } else {
      const errorText = await response.text();
      console.error(
        "❌ Failed to send client error via API:",
        response.status,
        errorText,
      );
    }
  } catch (loggingError) {
    console.error("❌ Error sending client error via API:", loggingError);
  }
};

// Test function
